import _ from 'lodash';
import { UPDATE_TRIAGE_ITEMS, SET_TRIAGE_USERS, SET_OPTION_MENU_OPEN } from './action-types';
import { mergeSocketArray } from 'utils/socket-utils';

export default function filters(state = { items: [], optionMenuStates: {} }, action) {
  const triageState = _.assign({}, state);

  switch (action.type) {
    case UPDATE_TRIAGE_ITEMS:
      triageState.items = mergeSocketArray(action.items, state.items, { id: 'triageId' });
      break;
    case SET_OPTION_MENU_OPEN:
      triageState.optionMenuStates = _.assign({}, triageState.optionMenuStates, { [action.itemIdentifier]: action.optionMenuOpen });
      break;
    case SET_TRIAGE_USERS:
      triageState.users = action.users;
      break;
    default:
      return state;
  }

  return triageState;
}

